import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge } from '../../../ui';
import { LoadingSpinner } from '../../../components/common/LoadingSpinner';
import { useCompanies } from '../../../hooks/useFinancialOps';
import { useBankImports } from '../hooks/useBankImports';
import { formatDateBR } from '../../../utils/format';
import type { BankImportSessionDTO } from '../services/bank-imports.service';

const TONE: Record<string, 'neutral' | 'accent' | 'warning' | 'danger'> = {
  PENDING: 'warning',
  PROCESSING: 'warning',
  EXTRACTED: 'warning',
  COMPLETED: 'accent',
  FAILED: 'danger',
};

export function ImportacoesListPage() {
  const { data: companiesData } = useCompanies({ active: true });
  const companies = companiesData?.data ?? [];
  const [companyId, setCompanyId] = useState('');
  const { data, isLoading } = useBankImports({ companyId });
  const sessions: BankImportSessionDTO[] = data?.data ?? [];

  return (
    <div className="p-6 space-y-4">
      <h1 className="text-xl font-semibold">Importações de extratos</h1>
      <select
        className="border rounded px-2 py-1"
        value={companyId}
        onChange={(e) => setCompanyId(e.target.value)}
      >
        <option value="">Selecione a empresa…</option>
        {companies.map((c: any) => (
          <option key={c.id} value={c.id}>
            {c.tradeName || c.name}
          </option>
        ))}
      </select>

      {isLoading && <LoadingSpinner />}

      {!isLoading && companyId && sessions.length === 0 && (
        <p className="text-ink-secondary">Nenhuma importação ainda.</p>
      )}

      {sessions.length > 0 && (
        <table className="w-full text-sm">
          <thead className="text-left text-ink-tertiary">
            <tr>
              <th>Data</th>
              <th>Conta</th>
              <th>Arquivo</th>
              <th>Período</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {sessions.map((s) => (
              <tr key={s.id} className="border-t border-border">
                <td className="py-2">{formatDateBR(s.createdAt)}</td>
                <td>
                  {s.bankAccount?.bankName} — {s.bankAccount?.name}
                </td>
                <td>{s.fileName}</td>
                <td>
                  {s.periodStart && s.periodEnd
                    ? `${formatDateBR(s.periodStart)} a ${formatDateBR(s.periodEnd)}`
                    : '—'}
                </td>
                <td>
                  <Badge tone={TONE[s.status] ?? 'neutral'}>{s.status}</Badge>
                </td>
                <td>
                  <Link to={`/financeiro/importacoes/${s.id}`} className="text-link">
                    Abrir
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
